import { render, staticRenderFns } from "./edit-proposal-buttons.vue?vue&type=template&id=bb5e349c&lang=pug"
import script from "./edit-proposal-buttons.vue?vue&type=script&lang=js"
export * from "./edit-proposal-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports